import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../store/app-state';
import { AppActions } from '../store/app-actions';

@Injectable()
export class AppHttpInterceptor implements HttpInterceptor {

  constructor(private router: Router,
              private store: Store<{app: AppState}>) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    req = req.clone({
      withCredentials: true,
    });

    return next.handle(req)
      .pipe(
        catchError((response: HttpErrorResponse) => {
          if ( response.error === 401 ){
            this.store.dispatch(AppActions.reset());
            this.router.navigate(['/login']);
          }

          throw response;
        })
      );

  }

}
